// @ts-nocheck
import { createFileRoute, Outlet, useRouterState } from '@tanstack/react-router'
import { useRouter } from 'next/router'
import { useQuery } from '@tanstack/react-query'
import Fetch from '@/utils/Fetch'
import styles from '@/PageComponents/CustomerZone/CustomerZoneDetail.module.css'


export const Route = createFileRoute('/_customerzoneLayout')({
  component: CustomerZoneLayout,
})

function CustomerZoneLayout() {
  const router = useRouter()
  const { t } = router.query
  const pathname = useRouterState({ select: s => s.location.pathname })
  const isHome = pathname === '/customerzone'

  const { data: tenantData } = useQuery(
    ['czTenant', t],
    () => Fetch.preLogin({ tenantID: t }),
    { enabled: !!t && !isHome }
  )
  const tenant = tenantData?.HttpStatusCode === 200 && tenantData.Results?.length > 0
    ? tenantData.Results[0] : null

  if (isHome) return <Outlet />

  if (tenantData && !tenant) {
    return (
      <>
        <div className={styles.navWrap}>
          <header className={styles.nav}>
            <div className={styles.navInner}>
              <a className={styles.navLogo} href="/customerzone">
                <img
                  src="/logo-type-white.svg"
                  alt="ServCraft"
                  onError={(e: any) => { e.target.style.display = 'none' }}
                />
              </a>
            </div>
          </header>
        </div>
        <div className={styles.root}>
          <div className={styles.page}>
            <div className={styles.wrap}>
              <div className={styles.invalidLink}>
                <p className={styles.invalidLinkTitle}>This link is invalid or has expired.</p>
                <p className={styles.invalidLinkBody}>Please contact the company you received this link from for a new one.</p>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  return <Outlet />
}
